import {
  Component,
  computed,
  inject,
  Injector,
  input,
  output,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxIconButtonComponent,
  OnyxInformationHeadingComponent,
  OnyxLinkComponent,
} from '@onyx/angular';
import type { Subject } from 'rxjs';
import { CommonHelper } from '../../../helpers/common.helper';
import { RouteHelper } from '../../../helpers/route.helper';
import { ROUTE_CONTEXT, RouteService } from '../../../services/route.service';
import { TelematicsStore } from '../../../stores/telematics.store';
import { RoutePointComponent } from '../../route/route-point/route-point.component';
import { ModalLoadingSectionComponent } from '../modal-loading-section/modal-loading-section.component';
import { SwapModalHelper } from './../../../../dashboard/map/common/helpers/swap/swap-modal.helper';

@Component({
  selector: 'app-modal-swap',
  imports: [
    ModalLoadingSectionComponent,
    RoutePointComponent,
    OnyxInformationHeadingComponent,
    OnyxLinkComponent,
    TranslatePipe,
    OnyxIconButtonComponent,
  ],
  providers: [{ provide: ROUTE_CONTEXT, useValue: 'map' }, RouteService],
  templateUrl: './modal-swap.component.html',
  styleUrl: './modal-swap.component.scss',
})
export class ModalSwapComponent {
  protected readonly telematicsStore = inject(TelematicsStore);
  private readonly router = inject(Router);
  private readonly injector = inject(Injector);
  private readonly swapModalHelper = inject(SwapModalHelper);

  public readonly vehicleUuid = input.required<string>();
  public readonly swapUuid = input.required<string | null>();
  public readonly close$ = input.required<Subject<void>>();

  public readonly reloadOrder = output<void>();

  protected readonly RouteHelper = RouteHelper;

  protected swap = computed(() => {
    const point = this.swapUuid()
      ? this.telematicsStore
          .swapPointBySwapAndVehicleUuid()
          .get(this.swapUuid()!)
          ?.get(this.vehicleUuid())
      : null;
    if (!point) return null;

    const data = RouteHelper.getSwapData(point)!;
    return { point, data };
  });

  protected showOnMap(): void {
    CommonHelper.showOnMap(this.router, this.vehicleUuid(), this.injector);
    this.close$().next();
  }

  protected openSwapModal(): void {
    const swapData = this.swap()?.data;
    if (swapData) {
      this.swapModalHelper.openModal(swapData.uuid, this.vehicleUuid());
    }
  }
}
